import { Component, OnInit, Input } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-cancel-order-modal',
  templateUrl: './cancel-order-modal.component.html',
  styleUrls: ['./cancel-order-modal.component.scss'],
  standalone: false
})
export class CancelOrderModalComponent implements OnInit {
  @Input() orderType: string;
  @Input() isOrder: boolean
  @Input() amount: any;

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {
    this.orderType = this.orderType.charAt(0).toUpperCase() + this.orderType.slice(1).toLowerCase();
  }

  viewYes() {
    this.modalCtrl.dismiss({ "status": "Yes" });
  }

  viewNo() {
    this.modalCtrl.dismiss({ "status": "No" });
  }
}
